<template>
  <div class="page_state_wrap">
    <div class="state_box">
      <div class="img_box">
        <img :src="showInfo.img" />
      </div>
      <h5>{{showInfo.text}}</h5>
    </div>
    <slot></slot>
  </div>
</template>

<script>
// i18n wiki: http://i18n.intra.didiglobal.com/product/view/10639
import { mapState } from 'vuex';
import { ORDER_STATE_MAP } from '@/const/entrega';
import success_img from './imgs/img_succeed.png';
import failed_img from './imgs/img_failed.png'
import success_img_99 from './imgs/img_succeed_99.png';
import failed_img_99 from './imgs/img_failed_99.png'

export default {
  name: 'PageState',
  props: {
    status: Number,
  },
  computed: {
    ...mapState({
      country: ({ common }) => common.country,
    }),
    is99() {
      return this.country === 'BR'
    },
    showInfo() {
      if (this.status === ORDER_STATE_MAP.complete) {
        return {
          img: this.is99 ? success_img_99 : success_img,
          text: this.$t('FoodC_progress_Order_completed_joIL' /* 订单已完成 */)
        }
      } else if (this.status === ORDER_STATE_MAP.cancel) {
        return {
          img: this.is99 ? failed_img_99 : failed_img,
          text: this.$t('FoodC_progress_Order_canceled_KDSH' /* 订单已取消 */)
        }
      }
      return false;
    }
  },
  mounted() {

  },
};
</script>

<style lang="scss" scoped>
.page_state_wrap {
  padding-bottom: rem(100);
}
.state_box {
  padding-top: rem(72);
  padding-bottom: rem(45);
  text-align: center;
  .img_box {
    margin: 0 auto;
    width: rem(430);
    height: rem(322);
    box-sizing: border-box;
    padding: rem(70) rem(68);
    img {
      width: 100%;
      height: 100%;
    }
  }
  h5 {
    padding: rem(28) rem(20) 0;
    font-size: rem(40);
    line-height: rem(46);
    font-weight: 500;
    font-family: 'Aspira Medium';
  }
}
</style>
